<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader></cnHeader>
		<div class="page_content">
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span>用户中心<span class="space">/</span>注册新账户
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="create_user_box">
				<!-- <div class="sign_icon"></div> -->
				<h1>注册新账户</h1>
				<h5>请使用您的常用电子邮件注册新帐户。</h5>
				<div class="input_box">
					<div class="item">
						<div class="title">电子邮件</div>
						<div class="e_input">
							<input class="in_txt" v-model="email" ref="email" type="text" maxlength="50" placeholder="请输入电子邮件地址" />
						</div>
					</div>
					<div class="item">
						<div class="title">登录密码</div>
						<div class="e_input">
							<input class="in_txt" v-model="password" ref="password" type="password" maxlength="20" placeholder="请设置登录密码" />
						</div>
					</div>
					<div class="item">
						<div class="title">确认密码</div>
						<div class="e_input">
							<input class="in_txt" v-model="re_password" ref="re_password" type="password" maxlength="20" placeholder="请再次输入登录密码" />
						</div>
					</div>
					<div class="error_text" v-if="errStatus">{{errMessage}}</div>
				</div>
				<div class="btns">
					<el-button type="primary" :loading="btnLoading" style="width: 100%;" @click="signCheck()">{{btnTxt}}</el-button>
				</div>
				<div class="space_txt">
					<div class="txt">如果您已经注册过账户，请在下面登录</div>
				</div>
				<div class="other_box">
					<div class="pub_btn" @click="toLogin()">登录</div>
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		userSign,
	} from '@/api/index.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_UserSign',
		components: {
			cnHeader,
			cnFooter,
		},
		data() {
			return {
				fullscreenLoading: false, //loading状态
				language: 'cn',
				terminal: 'pc',
				email: '',
				password: '',
				re_password: '',
				errStatus: false,	//错误状态
				errMessage: '',	//错误提示
				timer: null,
				
				btnLoading: false,
				btnTxt: '注册',
			}
		},
		created() {
			
		},
		beforeDestroy() {
			clearTimeout(this.timer)
		},
		methods: {
			// 注册
			async signCheck()
			{
				if(this.btnLoading)
				{
					return
				}
				
				if(this.email =='')
				{
					this.errStatus = true
					this.errMessage = '请输入电子邮件地址'
					this.$refs.email.focus()
					return
				}
				const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailPattern.test(this.email)) {
					this.errStatus = true
					this.errMessage = '电子邮件格式错误'
					this.$refs.email.focus()
					return
				}
					  
				if(this.password =='')
				{
					this.errStatus = true
					this.errMessage = '请输入登录密码'
					this.$refs.password.focus()
					return
				}
				if(this.password.length < 6)
				{
					this.errStatus = true
					this.errMessage = '密码长度不得小于6个字符'
					this.$refs.password.focus()
					return
				}
				
				if(this.re_password == '')
				{
					this.errStatus = true
					this.errMessage = '请再次输入登录密码'
					this.$refs.re_password.focus()
					return
				}
				if(this.re_password != this.password)
				{
					this.errStatus = true
					this.errMessage = '两次输入密码的不一致，请重新输入'
					this.$refs.re_password.focus()
					return
				}
				
				this.errStatus = false
				this.errMessage = ''
				
				this.btnLoading = true
				this.btnTxt = "处理中，请稍候..."
				this.fullscreenLoading = true
				
				let params = {
					Language: this.language,
					Email: this.email,
					Password: this.password,
				}
				const { data: res } = await userSign(params)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.$message.success('恭喜您，账号注册成功');
					this.timer = setTimeout(() => {
						this.$router.push({
							path: '/cn/user/login'
						})
					}, 500)
				} else {
					this.btnLoading = false
					this.btnTxt = "注册"
					this.fullscreenLoading = false
					this.$message.error(res.errmsg);
				}
			},
			// 去登录
			toLogin()
			{
				this.$router.push({
					path: '/cn/user/login'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;

		.el-button--primary {
			font-family: "PingFang SC", sans-serif, Helvetica, Arial;
			font-size: 15px;
			font-weight: 400;
			height: 42px;
			border: 0;
			border-radius: 8px;
			-webkit-transition: all .3s ease;
		}		
		.el-button--primary:focus {
			background-color: #008768;
		}
		.el-button--primary:hover {
			background-color: #000;
		}
	}
</style>